import { useEffect, useState } from "react"

export default function useScrollDirection(props: {
  thr?: number
  axis?: "x" | "y"
  scrollUp?: "up" | "left"
  scrollDown?: "down" | "right"
  still?: string
}) {
  const {
    thr = 0,
    axis = "y",
    scrollUp = axis === "y" ? "up" : "left",
    scrollDown = axis === "y" ? "down" : "right",
    still = "still",
  } = props
  const [scrollDir, setScrollDir] = useState<string>(still)

  useEffect(() => {
    const threshold = thr > 0 ? thr : 0
    let ticking = false
    let lastScroll: number

    axis === "y" ? (lastScroll = window.scrollY) : (lastScroll = window.scrollX)

    const updateScrollDir = () => {
      let scroll = undefined

      axis === "y" ? (scroll = window.scrollY) : (scroll = window.scrollX)

      if (Math.abs(scroll - lastScroll) < threshold) {
        ticking = false
        return
      }
      setScrollDir(scroll > lastScroll ? scrollDown : scrollUp)
      lastScroll = scroll > 0 ? scrollY : 0
      ticking = false
    }

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollDir)
        ticking = true
      }
    }

    window.addEventListener("scroll", onScroll)

    return () => window.removeEventListener("scroll", onScroll)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollDir])

  return scrollDir
}
